enum LoyaltyOption {
  LOYALTY = 'LOYALTY',
  MEMBERSHIP_GUIDE = 'MEMBERSHIP_GUIDE',
}

export default LoyaltyOption;
